import React, { useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

export default function BlogPage() {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://app.trysoro.com/api/embed/ab558a7b-7718-4b43-92da-13a5eab11d72';
    script.defer = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <>
      <Header />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 pb-2">
        <h1 className="text-4xl sm:text-5xl font-light text-neutral-900 tracking-tight" style={{ fontFamily: 'Cormorant Garamond, Georgia, serif' }} data-testid="blog-h1">
          Blog de interiorismo, arquitectura y remodelación
        </h1>
      </div>
      <main className="min-h-screen pt-20 pb-16" style={{ backgroundColor: '#FAF9F6' }}>
        <div className="max-w-5xl mx-auto px-4">
          <div id="soro-blog"></div>
        </div>
      </main>
      <Footer />
    </>
  );
}
